/* 
 * HTTP 请求服务接口扩展
 * 封装客户端向服务器发送的HTTP请求（GET、POST）
 * 封装的请求，已加入MYPROID授权码和请求服务器主地址，使用时不用再加入
 * 已封装HTPP相关URL地址的处理，支持URL地址参数根据参数名称获取其值
 */
'use strict'

import 'es6-promise/auto';
import JSMD5 from 'js-md5'; //MD5加密
import axios from 'axios';
import iView from 'view-design';

var SIGNKEY = "5A8SlvhJZLMXDZRK";
var CONTENT_TYPE = {
  "json": "application/json",
  "form-url" : "application/x-www-form-urlencoded"
};

var HttpClient = function () { this.ctype = "form-url"; return this; };

/**
 * 基础请求函数实现
 * @param {  string} mod  请求方法[get,post]
 * @param {  string} url  请求命令，也可以是完整的请求地址
 * @param {    json} data 请求数据，GET组合至URL地址请求
 * @param {function} yes  请求成功回调执行[result,status,JsXHR]
 * @param {function} err  请求异常回调执行[error]
 */
HttpClient.prototype.request = function(mod, url, data, yes, err, timeout) {
  var _that = this;
  var _cttype = CONTENT_TYPE[this.ctype];
  if (timeout==undefined) { timeout = 10000; }
  
  iView.LoadingBar.start();
  var instarg = axios.create({ timeout: timeout });
  switch(mod.toLowerCase()) 
  {
    case "get": 
      instarg.get(url)
        .then(function(result) { iView.LoadingBar.finish();  (yes || function(){}).call(this, result.data, result.status, result.request); })
        .catch(function(error) { iView.LoadingBar.error(); (err || function(){}).call(this, error); });
      break;
    case "post": 
      instarg.defaults.transformRequest = [function(data) {
        if (_that.ctype == "form-url") {
          let _data = undefined;
          // JSON字符串处理
          if (typeof(data) == "string") { try{ _data = JSON.parse(data); } catch(e) { _data = undefined; } }
          // JSON对象处理
          if (typeof(data) == "object") {
            if (Object.prototype.toString.call(data).toLowerCase() == "[object object]" && !data.length) { _data = data; }
            else if (Object.prototype.toString.call(data).toLowerCase() == "[object array]") { _data = JSON.parse(JSON.stringify(data)); }
          }
          if (_data != undefined) {
            let refData = [];
            for (let key in _data) { refData.push(key + '=' + encodeURIComponent(_data[key])); }
            data = refData.join('&');
          }
        }
        return data;
      }];
      instarg.post(url, data, { headers: { 'Content-Type': _cttype } })
        .then(function(result) { iView.LoadingBar.finish(); (yes || function(){}).call(this, result.data, result.status, result.request); })
        .catch(function(error) { iView.LoadingBar.error(); (err || function(){}).call(this, error); });
      break;
  };

};

/** 接口基础函数 */
var req_core = function() { this.chttp = new HttpClient(); return this; };

/**
 * 基础请求函数实现
 * @param {  string} url 请求命令，也可以是完整的请求地址
 * @param {function} yes 请求成功回调执行[result,status,JsXHR]
 * @param {function} err 请求异常回调执行[error]
 */
req_core.prototype.get = function(url, yes, err, timeout) {
  this.chttp.request("get", url, null, yes, err, timeout);
};
/**
 * 基础请求函数实现
 * @param {  string} url  请求命令，也可以是完整的请求地址
 * @param {    json} dat  请求数据，GET组合至URL地址请求
 * @param {function} yes  请求成功回调执行[result,status,JsXHR]
 * @param {function} err  请求异常回调执行[error]
 */
req_core.prototype.post = function(url, dat, yes, err, timeout) {
  this.chttp.request("post", url, dat, yes, err, timeout);
};
/**
 * 设置请求内容类型【json,from,from-url】
 * @param {string} type Conetnt-Type
 */
req_core.prototype.set_ctype = function(type) { this.chttp.ctype = type; };
/**
 * 请求数据签名
 * @param {  json} data  签名数据
 * @param {string} keys  签名字段
 * @param {string} agent 所属代理
 */
req_core.prototype.make_sign = function(data, keys) {  
  var sdts = [];
  keys.split(',').forEach(function(key) { sdts.push(data[key]); });
  return JSMD5(sdts.join('') + SIGNKEY);
};
/**
 * 获取请求地址
 * @param {string} action 请求ACTION
 * @param {string} key    所属[DW,RP,TG]
 */
req_core.prototype.get_url = function(action, key, data) {
  var url = action;
  if (key=="RP") { url = RPDT_API + action; }
  if (key=="TG") { url = AUTG_API + action; }
  if (key=="CPL") { url = TCPL_API + action; }
  if (data != null && data != undefined) {
    var qargs = [];
    for (var key in data) { qargs.push(key + '=' + encodeURIComponent(data[key])); }
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + qargs.join('&');
  }
  return url;
};

/// RP  auth              获取用户授权（:6001/api/redpack/）
/// RP  showlist          获取奖券领取记录（:6001/api/redpack/）
/// CPL pc/bind           CPL渠道授权绑定（:8001/cpl/）
/// CPL download/addr     获取CPL渠道下载地址（:8001/cpl/）
/// TG  bind              推广邀请绑定（:6001/api/wxspread/）
/// TG  web/uinfo         获取推广用户信息（:6001/api/wxspread/）
/// TG  web/transfer      提交兑换（:6001/api/wxspread/）
/// TG  web/invitedlist   获取推广记录（:6001/api/wxspread/）
/// TG  web/translist     获取兑换记录（:6001/api/wxspread/）

export default (function() { return new req_core(); })();



// WEBPACK FOOTER //
// ./src/assets/js/request.js